import map from "lodash/fp/map";
import isNil from "lodash/fp/isNil";
import constants from "../../core/constants";
import moment from "moment";
import isObject from "lodash/fp/isObject";
class BulkScriptsPageTransform {
  constructor() {
    "ngInject";

    this.fields = [
      {
        title: "Operator",
        name: "user",
      },
      {
        title: "Creation Date",
        name: "createdAt",
      },
      {
        title: "Successful Records",
        name: "number_of_successful_records",
      },
      {
        title: "Failed Records",
        name: "number_of_failed_records",
      },
      {
        title: "Pending Records",
        name: "number_of_pending_records",
      },
    ];
  }

  justify(data) {
    const format = (item) => {
      item.createdAt = moment(item.createdAt).format(constants.dateTimeFormat);
      item.user = isObject(item.user) ? item.user.name : item.user;
      if (!isNil(item.cityName)) {
        item.cityName = item.city.name;
      }
      item.number_of_pending_records =
        item.number_of_records -
        item.number_of_successful_records -
        item.number_of_failed_records;
      return item;
    };
    return map(format)(data);
  }
}

export default BulkScriptsPageTransform;



// WEBPACK FOOTER //
// ./src/pages/bulkScripts/bulkScripts.transforms.js